export type SmartOfficeInboundContactSyncSettingsFilters = {
  active?: boolean
  contactType?: string
  tags?: string[]
}

export type SmartOfficeInboundContactSyncSettings = {
  autoSync: boolean
  filters: SmartOfficeInboundContactSyncSettingsFilters
}

export type SmartOfficeInboundSyncSettings = {
  contact: SmartOfficeInboundContactSyncSettings
}

export type SmartOfficeSettingsFormValues = {
  inbound: SmartOfficeInboundSyncSettings
}

export const smartOfficeSettingsDefaultValues: SmartOfficeSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
      filters: {},
    },
  },
}
